// Prix « Créer votre chambre » — même grille que « Créez votre composition » (validée par Yann le 2026-10-03).
// Utilisé tel quel par le créateur (affichage) et par la fonction de remise Shopify (panier) : une seule source.
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.LnaRoomPricing = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // veilleuses + lettres → prix fixe en centimes ; au-delà de 6 : +28 € par veilleuse
  var GRID = { 2: 6900, 3: 9900, 4: 12900, 5: 14900, 6: 16900 };
  var EXTRA = 2800;
  var LIGHTS = { veilleuse: true, alphabet: true };

  function gridPrice(n) {
    if (n < 2) return null;
    return n <= 6 ? GRID[n] : GRID[6] + (n - 6) * EXTRA;
  }

  // Devise du client : la grille en euros est convertie puis arrondie à l'unité, comme Shopify arrondit les prix
  // des marchés hors euro (39 € → 38 CHF / 34 £). rate = taux Shopify (1 en euros).
  function toLocal(cents, rate) {
    return !rate || rate === 1 ? cents : Math.round((cents * rate) / 100) * 100;
  }

  function localGrid(n, rate) {
    var g = gridPrice(n);
    return g === null ? null : toLocal(g, rate);
  }


  // lines : [{ id, category, price (centimes, devise du client), quantity, supplement (centimes en euros), excluded }]
  // Paliers : veilleuses et lettres (sauf excluded, ex. Elephant Family) ; prix = grille + suppléments.
  // Premier pack de stickers offert dès 2 veilleuses (un seul, quel que soit le nombre de packs).
  function compute(lines, rate) {
    var count = 0, list = 0, supplements = 0, lightIds = [];
    lines.forEach(function (l) {
      if (!LIGHTS[l.category] || l.excluded) return;
      count += l.quantity;
      list += l.price * l.quantity;
      supplements += toLocal(l.supplement || 0, rate) * l.quantity;
      lightIds.push(l.id);
    });
    var target = localGrid(count, rate);
    var lightsDiscount = target === null ? 0 : Math.max(0, list - target - supplements);
    var pack = count >= 2 ? lines.filter(function (l) { return l.category === 'sticker'; })[0] : null;
    return {
      count: count,
      supplements: target === null ? 0 : supplements,
      lightIds: lightsDiscount ? lightIds : [],
      lightsDiscount: lightsDiscount,
      freePackId: pack ? pack.id : null,
      packDiscount: pack ? pack.price : 0
    };
  }

  // Ce que coûte une veilleuse de plus, sans supplément : prochain palier + suppléments déjà présents − ce que
  // coûtent déjà les veilleuses. C'est le minimum réel (une veilleuse à supplément coûtera ce prix + son supplément).
  function nextStep(lines, rate) {
    var r = compute(lines, rate), list = 0, supplements = 0;
    if (r.count < 1) return null;
    lines.forEach(function (l) {
      if (!LIGHTS[l.category] || l.excluded) return;
      list += l.price * l.quantity;
      supplements += toLocal(l.supplement || 0, rate) * l.quantity;
    });
    return { count: r.count + 1, price: localGrid(r.count + 1, rate) + supplements - (list - r.lightsDiscount) };
  }

  return { gridPrice: gridPrice, localGrid: localGrid, nextStep: nextStep, compute: compute };
});
